import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { func, string } from "prop-types";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { selectProposalOutlineSections } from "slices/proposalOutline/selectors";

import DocumentDetachOptions, {
  areDetachParamsValid,
  getInitialDetachParams,
} from "../DocumentDetachOptions";
import classes from "./DeleteOutlineModal.module.scss";

const hideModalAction = hideModal(modalTypes.DELETE_OUTLINE_MODAL);

const DeleteOutlineModal = ({ bodyText, onConfirm }) => {
  const dispatch = useDispatch();
  const sections = useSelector(selectProposalOutlineSections);

  const [deleteDocument, setDeleteDocument] = useState();
  const [detachParams, setDetachParams] = useState(
    getInitialDetachParams(sections)
  );
  const hasLinkedDocuments = Object.keys(detachParams).length > 0;

  const onDismiss = () => {
    dispatch(hideModalAction);
  };

  const onClickConfirm = () => {
    onConfirm({ detachParams, deleteDocument });
  };

  const isSubmitDisabled = useMemo(() => {
    switch (true) {
      case !hasLinkedDocuments:
        return false;
      case deleteDocument === true:
      case deleteDocument === false && areDetachParamsValid(detachParams):
        return false;
      default:
        return true;
    }
  }, [deleteDocument, detachParams, hasLinkedDocuments]);

  return (
    <Modal
      data-testid="delete-outline-modal"
      className="fade-in"
      show
      onDismiss={onDismiss}
      centered
    >
      <Modal.Header>Confirmation</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>{bodyText}</p>
        {hasLinkedDocuments && (
          <DocumentDetachOptions
            deleteDocument={deleteDocument}
            detachParams={detachParams}
            onChangeDelete={setDeleteDocument}
            onUpdateFileNames={setDetachParams}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="confirm-button"
          disabled={isSubmitDisabled}
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Continue
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

DeleteOutlineModal.propTypes = {
  bodyText: string.isRequired,
  onConfirm: func,
};

export default DeleteOutlineModal;
